<template>
  <!-- 评价课程问卷 -->
  <div class="questionnaire">
    <van-nav-bar :title="paperTit"
                 left-text
                 left-arrow
                 @click-left="onClickLeft" />
    <div class="banner"></div>
    <div class="qsdesp"
         v-show="qsdesp">{{ qsdesp }}</div>
    <div class="content"
         v-for="(bigType, qtIdx) in qsList"
         :key="qtIdx">
      <!-- 题型信息 -->
      <div class="qsType">
        <span>{{ bigOrder[qtIdx] }}</span>
        <span class="typeName">{{ bigType.qsType }}</span>
      </div>
      <!-- 题目内容详情 -->
      <div class="qsContent"
           v-for="(item, index) in bigType.qsDetails"
           :key="index">
        <div class="qsTit">
          {{ `${index + 1}.${item.qsTit}`
          }}<span v-if="
              item.select_count &&
                item.select_count != item.answer.length &&
                item.answer.length > 0
            ">{{ '(必须选择' + item.select_count + '项)' }}</span>
        </div>
        <div class="title_pic"
             v-show="item.picurl">
          <van-image fit="contain"
                     :src="item.picurl ? filesvrurl + '/' + item.picurl + '.png' : ''"
                     @click="imagePreview(filesvrurl + '/' + item.picurl + '.png')" />
        </div>
        <!-- 单选题 -->
        <van-radio-group v-if="bigType.qsType == '单选题'"
                         class="singleChoice"
                         v-model="item.answer">
          <div v-for="(opt, opIdx) in item.options"
               :key="opIdx">
            <van-radio :name="abList[opIdx]">
              <span class="iico">{{ abList[opIdx] }}</span>
              {{ opt.opTit }}
            </van-radio>
            <div class="option_pic"
                 v-show="item.pics[opIdx]">
              <van-image width="100%"
                         height="100%"
                         :src="
                  item.pics[opIdx]
                    ? filesvrurl + '/' + item.pics[opIdx] + '.png'
                    : ''
                "
                         @click="
                  imagePreview(filesvrurl + '/' + item.pics[opIdx] + '.png')
                " />
            </div>
          </div>
        </van-radio-group>
        <!-- 多选题 -->
        <van-checkbox-group v-model="item.answer"
                            v-else-if="bigType.qsType == '多选题'">
          <div v-for="(opt, opIdx) in item.options"
               :key="opIdx">
            <van-checkbox :name="abList[opIdx]">
              <span class="iico">{{ abList[opIdx] }}</span>
              {{ opt.opTit }}
            </van-checkbox>
            <div class="option_pic"
                 v-show="item.pics[opIdx]">
              <van-image width="100%"
                         height="100%"
                         :src="
                  item.pics[opIdx]
                    ? filesvrurl + '/' + item.pics[opIdx] + '.png'
                    : ''
                "
                         @click="
                  imagePreview(filesvrurl + '/' + item.pics[opIdx] + '.png')
                " />
            </div>
          </div>
        </van-checkbox-group>
        <!-- 判断题 -->
        <!-- <van-radio-group
          class="judge"
          v-model="item.answer"
          v-if="bigType.qsType == '判断题'"
          @change="judgeAnswer"
        >
          <van-radio name="1">正确</van-radio>
          <van-radio name="0">错误</van-radio>
        </van-radio-group>-->

        <!-- 打分题 -->
        <div v-if="bigType.qsType == '打分题'"
             style="display: flex; align-items: center; flex-wrap: wrap;">
          <van-rate v-model="item.answer"
                    :count="item.options.length"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee" />
          <div style="margin-left:10px;">
            {{ item.options[item.answer - 1] }}
          </div>
        </div>
        <!-- 简答题 -->
        <van-field class="brief"
                   v-if="bigType.qsType == '简答题'"
                   v-model="item.answer"
                   rows="10"
                   autosize
                   label
                   type="textarea"
                   maxlength="500"
                   placeholder="请输入答案"
                   show-word-limit />
        <!-- 上传题 -->
        <!-- <van-uploader
          v-if="bigType.qsType == '附件题'"
          v-model="item.answer"
          multiple
          :max-count="1"
        >
          <van-button icon="plus" type="info">上传文件</van-button>
        </van-uploader>-->
      </div>
    </div>
    <div class="footer">
      <van-button type="info"
                  @click="submitPaper">提交问卷</van-button>
    </div>
    <submitPrompt ref="submitPrompt"
                  :noAnswer="noAnswer"
                  :qsTotalNum="qsTotalNum"
                  :numdetail="numdetail" />
    <exitPrompt ref="exitPrompt"
                :noAnswer="noAnswer"
                :toPath="toPath"
                :toQuery="toQuery"
                :directJump="directJump" />

    <!-- 温馨提示弹窗 -->
    <van-dialog v-model="showTipDio"
                confirm-button-color="#2B8DF0"
                theme="round-button"
                class="countDownDio">
      <img :src="downUrl"
           alt />
      <div class="TipsContent"
           v-html="testpaperinfo"></div>
      <div class="countDownTxt">{{ countDownTxt }}</div>
    </van-dialog>
  </div>
</template>

<script>
import { ImagePreview, Notify } from 'vant'
import { Base64 } from 'js-base64'
import submitPrompt from './submitPrompt.vue'
import exitPrompt from './exitPrompt.vue'
import {
  checkWXPreInputStatus,
  saveQsTemplateOptionList
} from '@/request/api.js'
import { allClose } from '@/utils'
export default {
  components: { submitPrompt, exitPrompt },
  data () {
    // let redirect = '/seStaList?module=' + module
    // const r =
    //   redirect +
    //   '&tel=' +
    //   tel +
    //   '&restype=' +
    //   restype +
    //   '&tj_empid=' +
    //   this.tj_empid
    return {
      tel: '', //手机号码
      module: '', //模块号
      restype: '', //简历渠道
      zpacid: '', //活动id
      tj_empid: '',
      paperid: 0, //记录问卷的id
      mode: false, //一定是手机号模式登录
      m_attachfilepath: '',
      m_autoid: '',
      istest: '',
      paperTit: '', //问卷标题
      qsdesp: '', //问卷备注
      toPath: '',
      toQuery: {},
      bigOrder: ['一、', '二、', '三、', '四、', '五、', '六、', '七、'],
      abList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'],
      isfinish: false,
      currentQs: [],
      bgIdx: 0,
      smIdx: 0,
      qsList: [],
      filesvrurl: '', // 图片前缀
      showTipDio: false,
      downUrl: require('@/assets/img/count_down.png'),
      timer: null,
      countDownTxt: 10,
      directJump: '',
      testpaperinfo: '', // 提示信息
      submmited_qs: true, // 是否要保存文问卷
      showSeFormPop: false // 是否显示简历页的成功弹窗
    }
  },
  computed: {
    // 计算总共有多少道题
    qsTotalNum () {
      let num = 0
      if (this.qsList.length > 0)
      {
        this.qsList.forEach(item => {
          num += item.qsDetails.length
        })
      }
      return num
    },

    // 计算试卷有多少题没有答案
    noAnswer () {
      let num = 0
      if (this.qsList.length > 0)
      {
        this.qsList.forEach(qs => {
          if (qs.qsType == '单选题')
          {
            let ary = qs.qsDetails.filter(t => {
              return t.answer == ''
            })
            num += ary.length
          } else if (qs.qsType == '多选题')
          {
            let ary = qs.qsDetails.filter(t => {
              return (
                t.answer.length == 0 ||
                (t.answer.length != t.select_count && t.select_count > 0)
              )
            })
            num += ary.length
          } else if (qs.qsType == '简答题')
          {
            let ary = qs.qsDetails.filter(t => {
              return t.answer == ''
            })
            num += ary.length
          } else if (qs.qsType == '打分题')
          {
            let ary = qs.qsDetails.filter(t => {
              return t.answer == 0
            })
            num += ary.length
          }
        })
      }
      return num
    },
    numdetail () {
      let numdetail = {
        danxuan: [],
        duoxuan: [],
        duoxuan2: [],
        jd: [],
        df: []
      }
      if (this.qsList.length > 0)
      {
        this.qsList.forEach(qs => {
          if (qs.qsType == '单选题')
          {
            let ary = []
            qs.qsDetails.map((t, i) => {
              if (t.answer == '') ary.push(i + 1)
            })
            numdetail.danxuan = ary
          } else if (qs.qsType == '多选题')
          {
            let ary = []
            qs.qsDetails.map((t, i) => {
              if (t.answer.length == 0) ary.push(i + 1)
            })
            numdetail.duoxuan = ary
            ary = []
            qs.qsDetails.map((t, i) => {
              if (
                t.answer.length > 0 &&
                t.answer.length != t.select_count &&
                t.select_count > 0
              )
                ary.push(i + 1)
            })
            numdetail.duoxuan2 = ary
          } else if (qs.qsType == '简答题')
          {
            let ary = []
            qs.qsDetails.map((t, i) => {
              if (t.answer == '') ary.push(i + 1)
            })
            numdetail.jd = ary
          } else if (qs.qsType == '打分题')
          {
            let ary = []
            qs.qsDetails.map((t, i) => {
              if (t.answer == 0) ary.push(i + 1)
            })
            numdetail.df = ary
          }
        })
      }
      return numdetail
    }
  },
  created () {
    // 获取路由参数
    let params = this.$route.query.param || {}
    if (Object.keys(params).length > 0)
    {
      params = JSON.parse(Base64.decode(params))
    }
    this.module = params.module
    this.restype = params.restype
    this.tj_empid = params.tj_empid
    this.tel = params.tel
    this.m_attachfilepath = params.attachfilepath
    this.m_autoid = params.autoid
    this.istest = params.istest
    this.zpacid = params.zpacid
    this.directJump = params.directJump
    this.mode = params.mode

    // 判断各模块的参数获取
    if (isNaN(Number(this.module)))
    {
      // 不是数字
      this.testpaperinfo = window.comm ? window.comm.testpaperinfo : ''
    } else
    {
      // 是数字
      this.testpaperinfo = window['m' + this.module]
        ? window['m' + this.module].testpaperinfo
        : ''
    }
  },
  methods: {
    // 预览图片
    imagePreview (val) {
      ImagePreview([val])
    },
    // 提交试卷
    async submitPaper () {
      if (this.noAnswer)
      {
        console.log(this.numdetail)
        // 表示有没有答案的题目
        this.$refs.submitPrompt.show = true
      } else
      {
        this.submmited_qs = true
        this.showSeFormPop = false
        if (this.m_autoid > 0)
        {
          let pd = []
          if (this.qsList.length > 0)
          {
            this.qsList.forEach(item => {
              if (item.qsDetails.length > 0)
              {
                let ary = item.qsDetails.map(it => {
                  if (item.qsType == '多选题')
                  {
                    let answer = it.answer.join(',')
                    return { autoid: it.autoid, opres: answer }
                  } else
                  {
                    // 不是多选，就直接返回答案
                    return { autoid: it.autoid, opres: it.answer }
                  }
                })
                pd = pd.concat(ary)
              }
            })

            let params = {
              rsid: this.m_autoid,
              paperid: this.paperid,
              data: pd
            }
            await saveQsTemplateOptionList(params).then(res => {
              if (res.iserror == 0)
              {
                // 保存成功
                this.submmited_qs = false

                this.showSeFormPop = true
                Notify({
                  type: 'success',
                  message: '保存成功'
                })
              }
            })
          }
        }
        // 说明全部答完，则可以跳到填写简历信息的页面
        checkWXPreInputStatus({
          telephone: this.tel,
          moduleno: this.module
        }).then(res => {
          // 直接跳到填写简历信息页面（预入职）
          // let redirect =
          //   '/seForm?module=' + this.module + '&zpacid=' + this.zpacid
          // const r =
          //   redirect +
          //   '&tel=' +
          //   this.tel +
          //   '&attachfilepath=' +
          //   this.m_attachfilepath +
          //   '&autoid=' +
          //   this.m_autoid +
          //   '&mode=' +
          //   this.mode +
          //   '&restype=' +
          //   this.restype +
          //   '&paperid=' +
          //   this.paperid +
          //   '&tj_empid=' +
          //   this.tj_empid +
          //   '&submmited_qs=' +
          //   this.submmited_qs +
          //   '&showSeFormPop=' +
          //   this.showSeFormPop
          // this.$router.push(r)
          const param = {
            module: this.module,
            zpacid: this.zpacid,
            tel: this.tel,
            attachfilepath: this.m_attachfilepath,
            autoid: this.m_autoid,
            mode: this.mode,
            restype: this.restype,
            paperid: this.paperid,
            tj_empid: this.tj_empid,
            submmited_qs: this.submmited_qs,
            showSeFormPop: this.showSeFormPop
          }
          this.$router.push({
            path: "/seForm",
            query: { param: Base64.encode(JSON.stringify(param)) }
          })
        })
      }
    },

    // 点击返回
    onClickLeft () {
      if (this.noAnswer > 0)
      {
        this.$refs.exitPrompt.show = true
        this.toPath = '/seStaList'
        this.toQuery = {
          module: this.module,
          tel: this.tel,
          attachfilepath: this.m_attachfilepath,
          autoid: this.m_autoid,
          mode: this.mode,
          restype: this.restype,
          paperid: this.paperid,
          tj_empid: this.tj_empid,
          istest: this.istest
        }
      } else
      {
        if (this.directJump == 'true' || this.directJump == true)
        {
          allClose()
        } else
        {
          // this.$router.push('/seStaList')
          // let redirect = '/seStaList?module=' + this.module
          // const r =
          //   redirect +
          //   '&tel=' +
          //   this.tel +
          //   '&attachfilepath=' +
          //   this.m_attachfilepath +
          //   '&autoid=' +
          //   this.m_autoid +
          //   '&mode=' +
          //   this.mode +
          //   '&restype=' +
          //   this.restype +
          //   '&paperid=' +
          //   this.paperid +
          //   '&tj_empid=' +
          //   this.tj_empid +
          //   '&istest=' +
          //   this.istest
          // this.$router.push(r)
          const param = {
            module: this.module,
            tel: this.tel,
            attachfilepath: this.m_attachfilepath,
            autoid: this.m_autoid,
            mode: this.mode,
            restype: this.restype,
            paperid: this.paperid,
            tj_empid: this.tj_empid,
            istest: this.istest
          }
          this.$router.push({
            path: "/seStaList",
            query: { param: Base64.encode(JSON.stringify(param)) }
          })
        }
      }
    }
  },
  watch: {
    qsList: {
      handler (n) {
        // 只要问卷数据有变化就保存到localstorage
        if (n)
        {
          localStorage.setItem('questionData', JSON.stringify(n))
        }
      },
      deep: true
    }
  },

  mounted () {
    this.$nextTick(() => {
      let qsData = JSON.parse(localStorage.getItem('questionData'))
      let baseinfo = qsData.baseinfo
      this.filesvrurl = qsData.baseinfo[0].filesvrurl
      let paperData = qsData.data
      this.paperTit = baseinfo[0].qsname
      this.qsdesp = baseinfo[0].qsdesp
      this.paperid = baseinfo[0].paperid
      let typeAry = []
      let type = [0, 1, 4, 2]
      let bigAry = []
      type.forEach(item => {
        let ary = paperData.filter(it => {
          return it.opflag == item
        })
        typeAry.push(ary)
      })
      typeAry.forEach((qt, index) => {
        if (index == 0)
        {
          // 单选
          // 定义一个装单选题的对象
          if (qt.length > 0)
          {
            let qsTypeList = { qsType: '单选题', qsDetails: [] }
            qt.forEach(item => {
              let sigle = {
                autoid: 0,
                qsTit: '',
                answer: '',
                picurl: '',
                pics: [],
                options: []
              }
              sigle.qsTit = item.optitle //单选题的题目
              sigle.picurl = item.picurl
              sigle.pics = item.itemurl ? item.itemurl.split(',') : []
              sigle.autoid = item.autoid //单选题的autoid
              let opAry = item.oplist.split('|') //单选题的选项进行切割成数组
              opAry.forEach(it => {
                let op = { opTit: '' }
                op.opTit = it
                sigle.options.push(op)
              })
              qsTypeList.qsDetails.push(sigle)
            })
            bigAry.push(qsTypeList)
          }
        } else if (index == 1)
        {
          // 多选
          // 定义一个装多选题的对象
          if (qt.length > 0)
          {
            let qsTypeList = { qsType: '多选题', qsDetails: [] }
            qt.forEach(item => {
              let dx = {
                autoid: 0,
                qsTit: '',
                picurl: '',
                pics: [],
                answer: [],
                options: [],
                select_count: 0
              }
              dx.qsTit = item.optitle //多选题的题目
              /*
              如果select_count=0则不限制选多少个选择（至少选1个）；
              如果select_count>0例如=2，则表示必须选2个选项才能提交；
              */
              dx.select_count = item.select_count //多选题的题目
              dx.picurl = item.picurl
              dx.pics = item.itemurl ? item.itemurl.split(',') : []
              dx.autoid = item.autoid //多选题的autoid
              let opAry = item.oplist.split('|') //多选题的选项进行切割成数组
              opAry.forEach(it => {
                let op = { opTit: '' }
                op.opTit = it
                dx.options.push(op)
              })
              qsTypeList.qsDetails.push(dx)
            })
            bigAry.push(qsTypeList)
          }
        } else if (index == 3)
        {
          if (qt.length > 0)
          {
            // 简答
            // 定义一个装简答题的对象
            let qsTypeList = { qsType: '简答题', qsDetails: [] }
            qt.forEach(item => {
              let jd = { autoid: 0, qsTit: '', picurl: '', answer: '' }
              jd.qsTit = item.optitle //简答题的题目
              jd.picurl = item.picurl
              jd.autoid = item.autoid //简答题的autoid
              qsTypeList.qsDetails.push(jd)
            })
            bigAry.push(qsTypeList)
          }
        } else if (index == 2)
        {
          if (qt.length > 0)
          {
            // 打分
            let qsTypeList = { qsType: '打分题', qsDetails: [] }
            qt.forEach(item => {
              let df = {
                autoid: 0,
                qsTit: '',
                picurl: '',
                options: [],
                answer: 0
              }
              df.qsTit = item.optitle //打分题的题目
              df.picurl = item.picurl
              df.options = item.oplist.split('|') // 每颗星的描述
              df.autoid = item.autoid //打分题的autoid
              qsTypeList.qsDetails.push(df)
            })
            bigAry.push(qsTypeList)
          }
        }
      })
      this.qsList = JSON.parse(JSON.stringify(bigAry))

      // 如果提示信息不为空则弹出
      if (this.testpaperinfo)
      {
        // 弹出提示
        this.showTipDio = true
        this.countDownTxt = 10
        this.timer = setInterval(() => {
          if (this.countDownTxt > 0)
          {
            this.countDownTxt--
          } else
          {
            clearInterval(this.timer)
            this.showTipDio = false
          }
        }, 1000)
      }
    })
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "countDownFont";
  src: url("~@/assets/fonts/DS-DIGIB.TTF");
}
.countDownDio {
  .van-dialog__content {
    .TipsContent {
      padding: 40px;
      font-size: 32px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #333333;
      max-height: 400px;
      overflow-y: auto;
    }
    .countDownTxt {
      text-align: center;
      font-family: "countDownFont";
      font-size: 100px;
      color: #2b8df0;
    }
  }
}
.questionnaire {
  background: #fff;
  height: 100vh;

  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #fff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .banner {
    height: 124px;
    background: url("~@/assets/img/examination1.png") no-repeat;
    background-size: cover;
    background-position-y: -150px;
  }
  .qsdesp {
    font-size: 30px;
    line-height: 1.5;
    padding: 20px 30px;
    border-bottom: 1px solid #ccc;
    color: #666;
  }
  .content {
    font-size: 36px;
    font-family: Source Han Sans SC;
    padding: 30px 0;
    border-bottom: 1px solid #ccc;
    background: #fff;
    .qsType {
      margin-bottom: 28px;
      border-bottom: 1px solid #ccc;
      padding: 0 30px;
      padding-bottom: 28px;
      .typeName {
        margin-right: 15px;
      }
      .grade {
        color: #2b8df0;
      }
    }
    .qsContent {
      padding: 36px 0;
      padding: 0 30px;
      color: #333;
      font-size: 32px;
      margin-bottom: 30px;
      .qsTit {
        margin-bottom: 42px;
        span {
          color: red;
        }
      }
      .title_pic {
        margin-bottom: 20px;
        .van-image {
          border: 1px solid #e1e6f0;
        }
      }
      .option_pic {
        margin-bottom: 20px;
        .van-image {
          border: 1px solid #e1e6f0;
        }
      }
      // 单选样式
      .singleChoice {
        padding-left: 1em;
        .van-radio {
          margin-bottom: 40px;
        }
        .van-radio {
          /deep/ .van-radio__icon--round {
            display: none;
          }
          /deep/.van-radio__label {
            margin-left: 0px;
          }
          /deep/ .iico {
            width: 60px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background: #ebebeb;
            border-radius: 50%;
            display: inline-block;
            margin-right: 16px;
          }
        }
        .van-radio[aria-checked="true"] {
          /deep/ .iico {
            display: none;
          }
          /deep/ .van-radio__icon--round {
            display: inline-block;
            width: 60px;
            height: 60px;
            margin-right: 16px;
            .van-icon {
              width: 100%;
              height: 100%;
              line-height: 60px;
              text-align: center;
            }
          }
        }
      }
      // 多选样式
      .van-checkbox-group {
        padding-left: 1em;
        .van-checkbox {
          margin-bottom: 40px;
        }
        .van-checkbox {
          /deep/ .van-checkbox__icon--round {
            display: none;
          }
          /deep/.van-checkbox__label {
            margin-left: 0px;
          }
          /deep/ .iico {
            width: 60px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            background: #ebebeb;
            border-radius: 50%;
            display: inline-block;
            margin-right: 16px;
          }
        }
        .van-checkbox[aria-checked="true"] {
          /deep/ .iico {
            display: none;
          }
          /deep/ .van-checkbox__icon--round {
            display: inline-block;
            width: 60px;
            height: 60px;
            margin-right: 16px;
            .van-icon {
              width: 100%;
              height: 100%;
              line-height: 60px;
              text-align: center;
            }
          }
        }
      }
      // 判断题样式
      .judge {
        padding-left: 1em;
        .van-radio {
          margin-bottom: 40px;
          /deep/ .van-radio__icon--round {
            display: inline-block;
            width: 60px;
            height: 60px;
            margin-right: 16px;
            .van-icon {
              width: 100%;
              height: 100%;
              line-height: 60px;
              text-align: center;
            }
          }
        }
      }
      // 填空题样式
      .tk {
        div {
          .van-cell {
            /deep/.van-cell__title {
              width: 4em;
              margin-right: 0;
            }
          }
          .zqdn {
            /deep/.van-cell__title {
              width: 5.3em;
              margin-right: 0;
            }
          }
        }
      }
      // 简答题样式
      .brief {
        display: flex;
        flex-direction: column;
        border: 1px solid #ccc;
      }
      // 上传题样式
      /deep/.van-uploader {
        width: 100%;
        /deep/.van-uploader__wrapper {
          display: flex;
          justify-content: flex-end;
          flex-flow: row-reverse;
          // flex-direction: column-reverse;
          /deep/.van-uploader__input-wrapper {
            // background: red;
            width: 50%;
            // width:80%;
          }
        }
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    // padding-bottom: 20px;
    height: 186px;
    line-height: 186px;
    .van-button {
      width: 80%;
    }
  }
}
</style>
